var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-items-stretch root map-bg" },
    [
      _c(
        "div",
        {
          staticClass: "z-index-1 d-flex flex-column align-items-stretch flex-1"
        },
        [
          _c("navbar", {
            attrs: {
              "active-sidebar": _vm.getActiveSidebar,
              "close-navbar-menus": _vm.closeNavbarMenus
            },
            on: {
              toggleNavbarMenu: function($event) {
                _vm.closeNavbarMenus = $event
              },
              showContacts: _vm.toggleContactsSidebar
            }
          }),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "d-flex flex-column flex-1 container content" },
            [
              _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                _vm.$route.name === "home"
                  ? _c("h1", { staticClass: "title pb-4 pb-md-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.title")) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _c("router-view", {
                    attrs: { "show-district": _vm.showDistrict },
                    on: { showDistrict: _vm.toggleDistrictSidebar }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sidebar",
                {
                  key: "sidebar-contacts",
                  attrs: { open: _vm.showContacts },
                  on: {
                    closeSidebar: function($event) {
                      _vm.showContacts = false
                    }
                  }
                },
                [_c("contacts", { attrs: { open: _vm.showContacts } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("site-footer")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }